import React, { useEffect } from 'react';
import { Zap } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ImprovementForm = ({ data, onChange, submitted }) => {
  useEffect(() => {
    if (data.length !== 3) {
      const newData = [...data];
      while (newData.length < 3) {
        newData.push({ name: "", value: "" });
      }
      if (newData.length > 3) {
        newData.splice(3);
      }
      onChange(newData);
    }
  }, [data.length, onChange]);

  const handleChange = (index, field, value) => {
    onChange((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], [field]: value };
      return newData;
    });
  };

  return (
    <div className={`space-y-6 p-8 rounded-3xl border transition-all ${submitted && data.some(item => !item.name || !item.value) ? "bg-red-50/30 border-red-200" : "bg-primary/5 border-primary/10"}`}>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
            <div className="p-2 bg-primary/20 text-primary rounded-lg">
                <Zap size={20} />
            </div>
            <h2 className="text-lg font-bold">Improvement Stats (Fixed 3 Stats) <span className="text-red-500">*</span></h2>
        </div>
        <span className="text-xs text-primary/60 bg-primary/10 px-3 py-1 rounded-full font-bold">3 items required</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data.map((item, index) => (
          <div key={index} className={`bg-white p-6 rounded-2xl border relative group shadow-sm transition-all hover:shadow-md ${submitted && (!item.name || !item.value) ? "border-red-500 shadow-red-50" : "border-slate-200"}`}>
            <div className="space-y-4">
              <div className="space-y-2">
                <Label className="text-xs uppercase tracking-widest text-slate-400 font-bold">Metric Name <span className="text-red-500">*</span></Label>
                <Input 
                  value={item.name} 
                  className={`bg-slate-50/50 border-none focus:bg-white transition-all shadow-none ${(!item.name && submitted) ? "ring-1 ring-red-500" : ""}`}
                  onChange={(e) => handleChange(index, 'name', e.target.value)} 
                  placeholder="e.g. Efficiency"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-xs uppercase tracking-widest text-slate-400 font-bold">Value Achieved <span className="text-red-500">*</span></Label>
                <Input 
                  value={item.value} 
                  className={`bg-slate-50/50 border-none focus:bg-white transition-all shadow-none font-bold text-primary ${(!item.value && submitted) ? "ring-1 ring-red-500" : ""}`}
                  onChange={(e) => handleChange(index, 'value', e.target.value)} 
                  placeholder="e.g. 40%"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImprovementForm;
